export default "__VITE_ASSET__B07L0HfU__"